import request from '@/utils/request'

export function getUserPage(params) {
  return request({
    url: '/api/wms/user/page',
    method: 'get',
    params
  })
}

export function getUserRoles(userId) {
  return request({
    url: `/api/wms/user/${userId}/roles`,
    method: 'get'
  })
}

export function assignUserRoles(userId, roleIds) {
  return request({
    url: `/api/wms/user/${userId}/roles`,
    method: 'put',
    data: roleIds
  })
}

export function addUser(data) {
  return request({
    url: '/api/wms/user',
    method: 'post',
    data
  })
}

export function updateUser(id, data) {
  return request({
    url: `/api/wms/user/${id}`,
    method: 'put',
    data
  })
}

export function deleteUser(id) {
  return request({
    url: `/api/wms/user/${id}`,
    method: 'delete'
  })
}

// 获取当前用户信息
export function getUserProfile() {
  return request({
    url: '/api/wms/user/profile',
    method: 'get'
  })
}

// 修改个人资料
export function updateUserProfile(data) {
  return request({
    url: '/api/wms/user/profile',
    method: 'put',
    data
  })
}

// 修改密码
export function changePassword(data) {
  return request({
    url: '/api/wms/user/changePassword',
    method: 'put',
    data
  })
}

// 管理员/经理重置用户密码
export function resetUserPassword(userId, password) {
  return request({
    url: `/api/wms/user/${userId}/password`,
    method: 'put',
    data: { password }
  })
}
